/**
 * True when the error comes from an aborted request (AbortController / axios cancel).
 * Avoid importing the axios instance here so Jest and tree-shaking stay simple; axios 1.x
 * uses `CanceledError` / `code === "ERR_CANCELED"` for both AbortSignal and legacy cancel.
 */
export function isAbortError(error) {
  if (error == null) return false;
  if (typeof error !== "object") return false;
  if (error.code === "ERR_CANCELED") return true;
  if (error.name === "CanceledError" || error.name === "AbortError") return true;
  return false;
}
